import PropTypes from 'prop-types';
import React, { useState } from 'react';

import PriceInput from './PriceInput';
import SizeInput from './SizeInput';
import style from '../../../../scss/components/form.module.scss';

const emptyInput = () => ({ size: '', price: '' });

const VariantListInput = ({
    entity,
    onChange,
    name,
    label,
    changedFields,
    resource,
    errors,
}) => {
    const values = Array.isArray(entity[name])
        ? entity[name].filter((v) => v && (v.size || v.price))
        : [];

    const [input, setInput] = useState(emptyInput());

    const handleAdd = () => {
        if (!input.size && !input.price) return;
        onChange({
            [name]: [
                ...values,
                { size: input.size || null, price: input.price || null },
            ],
        });
        setInput(emptyInput());
    };

    const handleRemove = (index) => {
        onChange({ [name]: values.filter((_, i) => i !== index) });
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleAdd();
        }
    };

    const canAdd = !!(input.size || input.price);

    return (
        <div className={style.formGroup}>
            {label && <label className={style.formLabel}>{label}</label>}

            {values.length > 0 && (
                <div
                    style={{
                        marginBottom: '8px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '4px',
                    }}
                >
                    {values.map((variant, index) => (
                        <div
                            key={index}
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '6px',
                                background: '#e8f4f8',
                                border: '1px solid #b0d4e3',
                                borderRadius: '4px',
                                padding: '4px 8px',
                                fontSize: '13px',
                                color: '#2d6a84',
                                width: 'fit-content',
                            }}
                        >
                            {variant.size && (
                                <span style={{ fontWeight: 500 }}>
                                    {variant.size}
                                </span>
                            )}
                            {variant.size && variant.price && (
                                <span style={{ color: '#9ab8c8' }}>—</span>
                            )}
                            {variant.price && <span>{variant.price}</span>}
                            <button
                                type="button"
                                onClick={() => handleRemove(index)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    cursor: 'pointer',
                                    color: '#e53e3e',
                                    fontSize: '16px',
                                    lineHeight: 1,
                                    padding: '0 2px',
                                    marginLeft: '2px',
                                }}
                                title="Remove"
                            >
                                ×
                            </button>
                        </div>
                    ))}
                </div>
            )}

            <div
                style={{ display: 'flex', gap: '8px', alignItems: 'flex-end' }}
                onKeyDown={handleKeyDown}
            >
                <div style={{ flex: 1 }}>
                    <SizeInput
                        entity={{ size_input: input.size }}
                        onChange={(updated) =>
                            setInput((prev) => ({
                                ...prev,
                                size: updated.size_input ?? '',
                            }))
                        }
                        name="size_input"
                        changedFields={changedFields}
                        resource={resource}
                        errors={errors}
                    />
                </div>
                <div style={{ flex: 1 }}>
                    <PriceInput
                        entity={{ price_input: input.price }}
                        onChange={(updated) =>
                            setInput((prev) => ({
                                ...prev,
                                price: updated.price_input ?? '',
                            }))
                        }
                        name="price_input"
                        changedFields={changedFields}
                        resource={resource}
                        errors={errors}
                    />
                </div>
                <button
                    type="button"
                    onClick={handleAdd}
                    disabled={!canAdd}
                    style={{
                        padding: '6px 12px',
                        background: canAdd ? '#3182ce' : '#cbd5e0',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: canAdd ? 'pointer' : 'not-allowed',
                        fontSize: '13px',
                        whiteSpace: 'nowrap',
                        marginBottom: '0',
                        height: '36px',
                        flexShrink: 0,
                    }}
                >
                    + Add
                </button>
            </div>
        </div>
    );
};

export default VariantListInput;

VariantListInput.propTypes = {
    entity: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    changedFields: PropTypes.array,
    resource: PropTypes.string,
    errors: PropTypes.object,
};

VariantListInput.defaultProps = {
    label: '',
    changedFields: [],
    resource: undefined,
    errors: null,
};
